import { useAppSelector } from 'hooks/reduxHooks'
import { isBedbank, isLpcHotel } from 'lib/offer/offerTypes'
import useBedbankRates from 'hooks/useBedbankRates'
import { EmptyObject } from 'lib/object/objectUtils'

interface Props {
  offer: App.AnyOffer | undefined;
  filters?: App.OfferListFilters;
}

function getSuggestedDates(state: App.State, filterKey: string | undefined, offer: App.OfferBase | undefined) {
  if (!filterKey || !offer?.id) {
    return undefined
  }
  return state.offer.searchResultMetadata.offerSuggestedDates?.[filterKey]?.[offer.id]
}

function useShouldHighlight({ offer, filters = EmptyObject }: Props): boolean {
  const filterFlexibleMonths = filters?.flexibleMonths

  const suggestedDates = useAppSelector(state =>
    getSuggestedDates(state, filterFlexibleMonths, offer),
  )

  const checkIn = filters?.checkIn ?? suggestedDates?.checkIn
  const checkOut = filters?.checkOut ?? suggestedDates?.checkOut

  const [, fetchingRates] =
    useBedbankRates(offer?.id, filters?.rooms, checkIn, checkOut) ?? [undefined, false]

  if (!offer || !filters) {
    return false
  }

  if (isLpcHotel(offer)) {
    return !!(
      filters.propertyId &&
      !filters.searchNearby &&
      (offer.property?.id ?? '') === filters.propertyId.split(':')[1]
    )
  }

  if (isBedbank(offer)) {
    return !!(
      !fetchingRates &&
      filters.propertyId &&
      !filters.searchNearby &&
      (offer.property?.id ?? '') === filters.propertyId.split(':')[1]
    )
  }

  return false
}

export default useShouldHighlight
